/**
 * /privacy — boilerplate Privacy Policy. Replace placeholders before
 * paying customers exist (data residency, sub-processors list,
 * jurisdiction-specific addenda).
 */

import React from 'react';
import PageHeader from '../../components/chrome/PageHeader';
import MarkdownContent from '../../components/chrome/MarkdownContent';
import { usePageMeta } from '../../hooks/usePageMeta';

const Privacy: React.FC = () => {
  usePageMeta(
    'Privacy Policy — GammaVision',
    'How GammaVision collects, uses, and stores your data. GDPR/CCPA compliant.',
  );
  return (
    <>
      <PageHeader title="PRIVACY POLICY" subtitle="Last updated: 2026-05-01." />
      <MarkdownContent>
        <h2>1. What we collect</h2>
        <p>Account info you provide (email, hashed password). Operational data (IP, user agent, request logs) needed to run the service. Payment metadata (last 4, expiry) stored by Stripe — we never see card numbers.</p>

        <h2>2. What we do with it</h2>
        <p>Operate the service, respond to support requests, prevent abuse, send transactional email, and improve the product. We do not sell your data.</p>

        <h2>3. Cookies</h2>
        <p>Strictly-necessary cookies for auth and session state. Optional analytics cookie to measure aggregate usage. You can decline analytics in your browser without losing functionality.</p>

        <h2>4. Sub-processors</h2>
        <ul>
          <li>Stripe — payments.</li>
          <li>Hetzner Cloud — application hosting (Ashburn, Virginia).</li>
          <li>Vercel — static site delivery.</li>
          <li>Tradier — market data (no personal data sent).</li>
        </ul>

        <h2>5. Retention</h2>
        <p>Account data is kept while your account is active and for 90 days after cancellation, then anonymised or deleted on request.</p>

        <h2>6. Your rights (GDPR / CCPA)</h2>
        <p>You can request a copy of your data, correction, deletion, or portability at any time by emailing <a href="mailto:privacy@gammavision.app" style={{ color: 'var(--cyan)' }}>privacy@gammavision.app</a>. We respond within 30 days.</p>

        <h2>7. Data location</h2>
        <p>Application servers run in the United States (Hetzner Cloud, Ashburn VA region). Static assets are served from Vercel's global edge network. Stripe handles payment data per its own data-residency rules.</p>

        <h2>8. Security</h2>
        <p>HTTPS for all traffic. Passwords stored hashed (compare_digest comparison). HTTP Basic auth gates the API; WebSocket upgrade carries a per-session token. Server-side dependencies are pinned and regularly updated.</p>

        <h2>9. Breach notification</h2>
        <p>If we discover a breach affecting your data, we notify you within 72 hours and provide guidance on protective steps.</p>

        <h2>10. Children</h2>
        <p>The service is not directed at anyone under 18. We do not knowingly collect data from minors.</p>

        <h2>11. Changes</h2>
        <p>We may update this policy. Material changes are announced by email at least 14 days before they take effect.</p>

        <h2>12. Contact</h2>
        <p>For privacy questions or data requests: <a href="mailto:privacy@gammavision.app" style={{ color: 'var(--cyan)' }}>privacy@gammavision.app</a>.</p>
      </MarkdownContent>
    </>
  );
};

export default Privacy;
